import {RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES} from "@pg-rp/navigation";

import type {ISearchInputRegion} from "../../../../search/components/ISearchInputValue";
import {SearchTab} from "../../../../search/types/SearchTab";
import {getPricesCityRegionId} from "../../constants/prices_cities_regions";
import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesRecentSearch} from "../../types/IPricesSearchModel";
import {getCityLink} from "../get_city_link";
import {getDistrictLink} from "./get_district_link";
import {getVoivodeshipByCitySlug} from "./get_voivodeship_by_city_slug";
import {isValidSearchInputRegion} from "./is_valid_search_input_region";
import {getPricesRecentCityId, getPricesRecentDistrictId} from "./prices_recent_searches_storage";

const {subtitles, subtitleSeparator} = PRICES_SEARCH_COPY;

const getPricesCity = (citySlug: string) => PRICES_CITIES.find((city) => city.slug === citySlug);

/** "Kraków", "Miasto · małopolskie"; null outside the 14 prices cities. */
export const buildPricesRecentCitySearch = (citySlug: string, timestamp: number, regionId?: number | null): IPricesRecentSearch | null => {
    const city = getPricesCity(citySlug);

    if (!city) {
        return null;
    }

    const voivodeship = getVoivodeshipByCitySlug(citySlug);
    const resolvedRegionId = regionId ?? getPricesCityRegionId(citySlug);

    return {
        id: getPricesRecentCityId(citySlug),
        kind: "city",
        title: city.name,
        subtitle: voivodeship ? `${subtitles.city}${subtitleSeparator}${voivodeship}` : subtitles.city,
        href: getCityLink(citySlug),
        timestamp,
        citySlug,
        ...(resolvedRegionId ? {regionId: resolvedRegionId} : {})
    };
};

/** "Mokotów", "Dzielnica · Warszawa", linked as `?dist=` on the city page; null outside the 14 prices cities. */
export const buildPricesRecentDistrictSearch = (
    district: Pick<ISearchInputRegion, "id" | "name" | "slug" | "short_name">,
    citySlug: string,
    timestamp: number
): IPricesRecentSearch | null => {
    const city = getPricesCity(citySlug);

    if (!city) {
        return null;
    }

    return {
        id: getPricesRecentDistrictId(district.id),
        kind: "district",
        title: district.name,
        subtitle: `${subtitles.district}${subtitleSeparator}${city.name}`,
        href: getDistrictLink(citySlug, district),
        timestamp,
        citySlug,
        regionId: district.id
    };
};

/** Slug of the prices city a region is (or is a district of); null for anything else (estates, towns, other cities). */
const getRegionPricesCitySlug = (region: ISearchInputRegion): string | null => {
    if (region.type === RegionType.CITY) {
        return getPricesCity(region.slug) ? region.slug : null;
    }

    if (region.type === RegionType.DISTRICT && region.parent) {
        return getPricesCity(region.parent.slug) ? region.parent.slug : null;
    }

    return null;
};

const mapMainRecentEntry = (entry: unknown): IPricesRecentSearch | null => {
    if (typeof entry !== "object" || entry === null) {
        return null;
    }

    const {search, timestamp} = entry as {search?: {tabType?: unknown; regions?: unknown}; timestamp?: unknown};

    if (search?.tabType !== SearchTab.Regions || !Array.isArray(search.regions) || typeof timestamp !== "number" || !Number.isFinite(timestamp)) {
        return null;
    }

    const regions: unknown[] = search.regions;

    if (regions.length === 0 || !regions.every(isValidSearchInputRegion)) {
        return null;
    }

    const citySlugs = new Set(regions.map(getRegionPricesCitySlug));
    const [citySlug] = [...citySlugs];

    // Every region must belong to one prices city; one district stays a district, anything else becomes the city.
    if (citySlugs.size !== 1 || !citySlug) {
        return null;
    }

    const [region] = regions;

    if (regions.length === 1 && region.type === RegionType.DISTRICT) {
        return buildPricesRecentDistrictSearch(region, citySlug, timestamp);
    }

    return buildPricesRecentCitySearch(citySlug, timestamp, regions.length === 1 ? region.id : null);
};

/**
 * Main search entries (`getRecentFilters()`, untrusted localStorage data) the prices search can show: a prices city,
 * a district of one, or several regions of the same city (shown as the city). Offers, places, vendors, voivodeships,
 * other cities and estates are skipped. Filters of the entry do not matter - the location is what is shown.
 */
export const mapMainRecentToPrices = (entries: readonly unknown[]): IPricesRecentSearch[] =>
    entries.flatMap((entry) => {
        try {
            const mapped = mapMainRecentEntry(entry);

            return mapped ? [mapped] : [];
        } catch {
            return [];
        }
    });
import {RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES} from "@pg-rp/navigation";

import type {ISearchInputRegion} from "../../../../search/components/ISearchInputValue";
import {SearchTab} from "../../../../search/types/SearchTab";
import {getPricesCityRegionId} from "../../constants/prices_cities_regions";
import {PRICES_SEARCH_COPY} from "../../constants/prices_search";
import type {IPricesRecentSearch} from "../../types/IPricesSearchModel";
import {getCityLink} from "../get_city_link";
import {getDistrictLink} from "./get_district_link";
import {getVoivodeshipByCitySlug} from "./get_voivodeship_by_city_slug";
import {isValidSearchInputRegion} from "./is_valid_search_input_region";
import {getPricesRecentCityId, getPricesRecentDistrictId} from "./prices_recent_searches_storage";

const {subtitles, subtitleSeparator} = PRICES_SEARCH_COPY;

const getPricesCity = (citySlug: string) => PRICES_CITIES.find((city) => city.slug === citySlug);

/** "Kraków", "Miasto · małopolskie"; null outside the 14 prices cities. */
export const buildPricesRecentCitySearch = (citySlug: string, timestamp: number, regionId?: number | null): IPricesRecentSearch | null => {
    const city = getPricesCity(citySlug);

    if (!city) {
        return null;
    }

    const voivodeship = getVoivodeshipByCitySlug(citySlug);
    const resolvedRegionId = regionId ?? getPricesCityRegionId(citySlug);

    return {
        id: getPricesRecentCityId(citySlug),
        kind: "city",
        title: city.name,
        subtitle: voivodeship ? `${subtitles.city}${subtitleSeparator}${voivodeship}` : subtitles.city,
        href: getCityLink(citySlug),
        timestamp,
        citySlug,
        ...(resolvedRegionId ? {regionId: resolvedRegionId} : {})
    };
};

/** "Mokotów", "Dzielnica · Warszawa", linked as `?dist=` on the city page; null outside the 14 prices cities. */
export const buildPricesRecentDistrictSearch = (
    district: Pick<ISearchInputRegion, "id" | "name" | "slug" | "short_name">,
    citySlug: string,
    timestamp: number
): IPricesRecentSearch | null => {
    const city = getPricesCity(citySlug);

    if (!city) {
        return null;
    }

    return {
        id: getPricesRecentDistrictId(district.id),
        kind: "district",
        title: district.name,
        subtitle: `${subtitles.district}${subtitleSeparator}${city.name}`,
        href: getDistrictLink(citySlug, district),
        timestamp,
        citySlug,
        regionId: district.id
    };
};

/** Slug of the prices city a region is (or is a district of); null for anything else (estates, towns, other cities). */
const getRegionPricesCitySlug = (region: ISearchInputRegion): string | null => {
    if (region.type === RegionType.CITY) {
        return getPricesCity(region.slug) ? region.slug : null;
    }

    if (region.type === RegionType.DISTRICT && region.parent) {
        return getPricesCity(region.parent.slug) ? region.parent.slug : null;
    }

    return null;
};

const mapMainRecentEntry = (entry: unknown): IPricesRecentSearch | null => {
    if (typeof entry !== "object" || entry === null) {
        return null;
    }

    const {search, timestamp} = entry as {search?: {tabType?: unknown; regions?: unknown}; timestamp?: unknown};

    if (search?.tabType !== SearchTab.Regions || !Array.isArray(search.regions) || typeof timestamp !== "number" || !Number.isFinite(timestamp)) {
        return null;
    }

    const regions: unknown[] = search.regions;

    if (regions.length === 0 || !regions.every(isValidSearchInputRegion)) {
        return null;
    }

    const citySlugs = new Set(regions.map(getRegionPricesCitySlug));
    const [citySlug] = [...citySlugs];

    // Every region must belong to one prices city; one district stays a district, anything else becomes the city.
    if (citySlugs.size !== 1 || !citySlug) {
        return null;
    }

    const [region] = regions;

    if (regions.length === 1 && region.type === RegionType.DISTRICT) {
        return buildPricesRecentDistrictSearch(region, citySlug, timestamp);
    }

    return buildPricesRecentCitySearch(citySlug, timestamp, regions.length === 1 ? region.id : null);
};

/**
 * Main search entries (`getRecentFilters()`, untrusted localStorage data) the prices search can show: a prices city,
 * a district of one, or several regions of the same city (shown as the city). Offers, places, vendors, voivodeships,
 * other cities and estates are skipped. Filters of the entry do not matter - the location is what is shown.
 */
export const mapMainRecentToPrices = (entries: readonly unknown[]): IPricesRecentSearch[] =>
    entries.flatMap((entry) => {
        try {
            const mapped = mapMainRecentEntry(entry);

            return mapped ? [mapped] : [];
        } catch {
            return [];
        }
    });
